import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-airConditioning",
  "use": "dv-airConditioning-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"dv-airConditioning\"><defs><style>#dv-airConditioning .cls-1{fill:#fff1de;fill-opacity:0}</style></defs><title>组 2483</title><g id=\"dv-airConditioning_图层_2\" data-name=\"图层 2\"><g id=\"dv-airConditioning_图层_1-2\" data-name=\"图层 1\"><g id=\"dv-airConditioning_组_2483\" data-name=\"组 2483\"><path id=\"dv-airConditioning_矩形_275\" data-name=\"矩形 275\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><path id=\"dv-airConditioning_路径_1255\" data-name=\"路径 1255\" d=\"M23.72 6a.53.53 0 0 0-.53-.53H.82A.53.53 0 0 0 .29 6L0 11.72l.28 5.69a.52.52 0 0 0 .53.53h1.77v-1.47h19v1.47h1.64a.52.52 0 0 0 .52-.53l.26-5.69zm-5.61 5.2H2.58V9.47h15.53zm2.57.07a.88.88 0 0 1 0-1.76.88.88 0 1 1 0 1.76zM3 16.89h18v1.5H3z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-airConditioning.svg
// module id = fWSF
// module chunks = 6